document.addEventListener("click", function (e) {
  const header = document.querySelector(".header");

  // Open popup
  const openBtn = e.target.closest(".variant-info-icon");
  if (openBtn) {
    const wrapper = openBtn.closest(".variant-option");
    const popup = wrapper?.querySelector(".variant-info-popup");

    if (popup) {
      popup.classList.add("active");
      document.body.classList.add("overflow_hidden");
      header?.classList.add("hidden");
    }
    return;
  }

  // Close button
  const closeBtn = e.target.closest(".close-info-icon");
  if (closeBtn) {
    const popup = closeBtn.closest(".variant-info-popup");

    if (popup) {
      popup.classList.remove("active");
      document.body.classList.remove("overflow_hidden");
      header?.classList.remove("hidden");
    }
    return;
  }

  // Click overlay
  if (e.target.classList.contains("variant-info-popup")) {
    e.target.classList.remove("active");
    document.body.classList.remove("overflow_hidden");
    header?.classList.remove("hidden");
  }
});